const colorChange = (rowData) => {
	switch (true) {
		case rowData === "Critical" ||
			rowData === "Reject" ||
			rowData === "Close" ||
			rowData === "Out Time":
			return {
				backgroundColor: "#CC0101",
				color: "#fff",
			};
		case rowData === "Open" || rowData === "Finish" || rowData === "In Time":
			return {
				backgroundColor: "#00AB55",
				color: "#fff",
			};
		case rowData === "High":
			return {
				backgroundColor: "#CC4400", //8A34A3
				color: "#fff",
			};
		case rowData === "Medium":
			return {
				backgroundColor: "#FFBF01",
				color: "#FFF9B7",
			};
		case rowData === "Low":
			return {
				backgroundColor: "#D5FF00",
				color: "#7D7D52",
			};
		case rowData === "On Progress":
			return {
				backgroundColor: "#2E69A3",
				color: "#fff",
			};
		default:
			return {
				backgroundColor: "#fff",
				color: "#000",
			};
	}
};

export default colorChange;
